import type { EntregaDoPedido } from "@bookdental/schemas";
import { trpc } from "@/lib/trpc";
import { entregaDoPedido, type ColunasDeEntrega } from "./endereco-de-entrega";

/**
 * O endereço de envio que vale sem troca: o que o pedido em edição já tem ou, no pedido novo, o da
 * clínica — o mesmo que o servidor usa quando o pedido chega sem endereço.
 */
export function useEntregaPadrao(editando?: ColunasDeEntrega | null): EntregaDoPedido | null {
  const perfil = trpc.organization.getProfiles.useQuery(undefined, { enabled: !editando });
  if (editando) return entregaDoPedido(editando);
  const d = perfil.data;
  if (!d?.mainAddress?.address) return null;
  const a = d.mainAddress;
  return {
    destinatario: d.name,
    telefone: d.phone ?? "",
    cep: a.zipCode ?? "",
    endereco: a.address ?? "",
    numero: a.addressNumber ?? "",
    complemento: a.addressComplement ?? "",
    bairro: a.neighborhood ?? "",
    cidade: a.city ?? "",
    uf: (a.state ?? "SP") as EntregaDoPedido["uf"],
  };
}
